import { render, staticRenderFns } from "./RegisterFederacao.vue?vue&type=template&id=1fa1e62d&"
import script from "./RegisterFederacao.vue?vue&type=script&lang=js&"
export * from "./RegisterFederacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports